import baseLogger from '@/common/services/BaseLogger'
import * as amplitude from '@amplitude/analytics-browser'
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'
import getConfig from 'next/config'
import { getClientDeviceId } from '@/common/libs/identity'
import { isbot } from 'isbot'

class UserAmplitudeAnalytics {
  isInit = false
  isInitError = false

  get isError() {
    return this.isInitError
  }

  trackEvent = (eventName, eventProperties) => {
    if (process.env.IS_DEV === 'true') {
      return
    }

    amplitude.track(eventName, eventProperties)
  }

  addUserProperties = (callback) => {
    const identifyEvent = new amplitude.Identify()

    callback(identifyEvent)
    amplitude.identify(identifyEvent)
  }

  init = (userAgent) => {
    try {
      if (process.env.IS_DEV === 'true' && isbot(userAgent)) {
        this.isInitError = true
        baseLogger.logger.info('analytic run only on production environment')
        return
      }

      const deviceId = getClientDeviceId()
      const key = getConfig().publicRuntimeConfig.amplitudeApiKey

      amplitude.init(key, null, {
        deviceId,
        includeUtm: true,
        includeReferrer: true,
      })

      baseLogger.logger.info('Initialized amplitude analytics', {
        device_id: deviceId,
      })

      const sessionReplayTracking = sessionReplayPlugin({
        sampleRate: 0.05,
        api_key: key,
      })
      amplitude.add(sessionReplayTracking)
      this.isInit = true
    } catch (error) {
      baseLogger.logger.info('failed init amplitude')
      this.isInitError = true
    }
  }
}

export const userAmplitudeAnalytics = new UserAmplitudeAnalytics()
